import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { scrollHandler } from '../utils/dom';

const navLinks = [
    { label: 'Home', href: '/', isRoute: true },
    { label: 'Features', href: '/#features', isRoute: false },
    { label: 'About', href: '/about', isRoute: true },
    { label: 'Pricing', href: '/#pricing', isRoute: false },
    { label: 'FAQ', href: '/faqs', isRoute: true },
    { label: 'Contact', href: '/contact', isRoute: true },
];

const LandingHeader = ({ isAuthenticated, onLogin, onLogout, onRegister, onDashboard }) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', scrollHandler);
        return () => window.removeEventListener('scroll', scrollHandler);
    }, []);

    useEffect(() => {
        if (mobileOpen) {
            document.body.classList.add('wsactive');
        } else {
            document.body.classList.remove('wsactive');
        }

        return () => {
            document.body.classList.remove('wsactive');
        };
    }, [mobileOpen]);

    const toggleMobile = () => {
        setMobileOpen((prev) => !prev);
    };

    const handleNavigate = () => {
        setMobileOpen(false);
    };

    const handleAction = (action) => {
        return () => {
            setMobileOpen(false);
            action();
        };
    };

    return (
        <header id="header" className="header tra-menu navbar-light">
            <div className="header-wrapper">
                <div className="wsmobileheader clearfix">
                    <span className="smllogo">
                        <img src="/assets/logo/logo-crop.png" alt="mobile-logo" />
                    </span>
                    <button id="wsnavtoggle" onClick={toggleMobile} className={`wsanimated-arrow${mobileOpen ? ' active' : ''}`}>
                        <span />
                    </button>
                </div>
                <div className="wsmainfull menu clearfix">
                    <div className="wsmainwp clearfix">
                        <div className="desktoplogo">
                            <Link to="/" className="logo-black" onClick={handleNavigate}>
                                <img src="/assets/logo/logo-crop.png" alt="header-logo" />
                            </Link>
                        </div>
                        <div className="desktoplogo">
                            <Link to="/" className="logo-white" onClick={handleNavigate}>
                                <img src="/assets/logo/logo-crop.png" alt="header-logo" />
                            </Link>
                        </div>
                        <nav className="wsmenu clearfix">
                            <div className="overlapblackbg" onClick={toggleMobile} />
                            <ul className={`wsmenu-list nav-stateblue-hover${mobileOpen ? ' wsactive' : ''}`}>
                                {navLinks.map((item) => (
                                    <li key={item.href} className="nl-simple" onClick={handleNavigate}>
                                        {item.isRoute ? (
                                            <Link to={item.href}>{item.label}</Link>
                                        ) : (
                                            <a href={item.href}>{item.label}</a>
                                        )}
                                    </li>
                                ))}
                                {!isAuthenticated ? (
                                    <>
                                        <li className="nl-simple">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-tra-grey tra-stateblue-hover"
                                                onClick={handleAction(onLogin)}
                                            >
                                                Log In
                                            </button>
                                        </li>
                                        <li className="nl-simple">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-stateblue tra-grey-hover"
                                                onClick={handleAction(onRegister)}
                                            >
                                                Get Started
                                            </button>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        <li className="nl-simple">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-tra-grey tra-stateblue-hover"
                                                onClick={handleAction(onDashboard)}
                                            >
                                                Dashboard
                                            </button>
                                        </li>
                                        <li className="nl-simple">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-stateblue tra-grey-hover"
                                                onClick={handleAction(onLogout)}
                                            >
                                                Log Out
                                            </button>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default LandingHeader;
